import { Injectable } from '@angular/core';
import { LoginModel } from '../../shared/models/login-model';
import { HttpRequestService } from '../http/http-request.service';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/configs';

@Injectable()
export class LoginService {

  constructor(private httpRequest: HttpRequestService, private router: Router, private appconfigservice: AppConfigService) { }

  tryLogin(loginData: LoginModel) {
    const body = new HttpParams()
      .set('username', loginData.email.value)
      .set('password', loginData.password.value);
    return this.httpRequest.post('login', body, true);
  }

  logout() {
     window.location.href= this.appconfigservice.tempApiPath + 'logout';
  }
}
